'use client';

import { Spinner, Text } from '@stone-payments/jade';
import { useIntl } from 'react-intl';
import { LoadingWrapper } from './loading.styles';

export const LoadingState = ({ fullPage }: { fullPage?: boolean }) => {
  const { formatMessage } = useIntl();
  return (
    <LoadingWrapper fullPage={fullPage} data-testid='loading'>
      <Spinner size="large" color="brand" />
      <Text>{formatMessage({ id: 'loadingState.message' })}</Text>
    </LoadingWrapper>
  );
};
